import { buildJobNavigationTargetUrl } from "../../searchResultNavigation";

const getJobIdFromValues = values => {
  const jobId = Number(values?.item?.id ?? values?.id);
  return Number.isInteger(jobId) && jobId > 0 ? jobId : null;
};

const buildJobDetailsHref = ({ jobId, search = "" }) => {
  const queryParams = new URLSearchParams(search);
  const listId = queryParams.get("listId");
  const workingListId = queryParams.get("workingListId");

  return buildJobNavigationTargetUrl({
    listContext: {
      ...(listId ? { listId } : {}),
      ...(workingListId ? { workingListId } : {}),
    },
    recordId: jobId,
    status: queryParams.get("status") || "all",
  });
};

export { buildJobDetailsHref, getJobIdFromValues };
